import { render, staticRenderFns } from "./SalesReservationD.vue?vue&type=template&id=e70f1ffa&scoped=true&"
import script from "./SalesReservationD.vue?vue&type=script&lang=js&"
export * from "./SalesReservationD.vue?vue&type=script&lang=js&"
import style0 from "./SalesReservationD.vue?vue&type=style&index=0&id=e70f1ffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70f1ffa",
  null
  
)

export default component.exports